import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IPriceListItem } from '@/_types'

/**
 * Fetches a single price-list item by id (detail page or cart enrichment).
 *
 * @param id - `IPriceListItem` primary key; must be positive for the query hook.
 */
export const fetchPriceListItemDetail = async (
	id: number
): Promise<ApiResponse<IPriceListItem>> => {
	return axios
		.get<ApiResponse<IPriceListItem>>(`v1/web/priceListItems/${id}`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchPriceListItemDetail}; disabled when `id <= 0`.
 *
 * @param id - Price-list item id.
 */
export const useGetPriceListItemDetail = (id: number) => {
	return useQuery<ApiResponse<IPriceListItem>>({
		queryKey: ['price-list-item', id],
		queryFn: () => fetchPriceListItemDetail(id),
		enabled: id > 0,
		select: data => data
	})
}
